import { type FC } from 'react'

import { type OfferSellerV1 } from '@redteclab/api/clients/bully'

import { Link } from 'base-ui'

import { useSellerModalContext } from '../../../../../seller'
import { useProductPageContext } from '../../../productPageContext'

type ProductOfferSellerLinkProps = {
  seller: OfferSellerV1
}

export const ProductOfferSellerLink: FC<ProductOfferSellerLinkProps> = ({
  seller,
}) => {
  const { product } = useProductPageContext()

  const { showSellerModal } = useSellerModalContext()

  return (
    <Link
      className="flex text-left font-medium"
      onClick={() => {
        if (seller.sellerId) {
          showSellerModal({
            productUpid: product.upid,
            sellerId: seller.sellerId,
          })
        }
      }}
      slots={{ root: 'button' }}
      type="button"
    >
      {seller.displayName}
    </Link>
  )
}
